import { FC } from "react";
import { HeaderWrapper, IconWrapper, LinkedInWrapper, UnderLineText } from "./styles";
import { StartProjectContactInfo } from "../../../models/startProject";
import { Block, Box, Image } from "../../../styles/basicStyles";
import { colors } from "../../../styles/colors";
import { Trans, useTranslation } from "next-i18next";
import Typography from "../../../components/typography";
import Icon from "../../../components/icon";
import Link from "../../../components/link";

interface ProjectFormProps {
  contactInfo?: StartProjectContactInfo;
}

const ProjectForm: FC<ProjectFormProps> = ({ contactInfo }) => {
  const { t } = useTranslation();

  return (
    <HeaderWrapper>
      <Box fWrap='wrap'>
        <Block 
          w={{ md: "60%", xxs: "100%" }} 
          pr={{ md: "2", xxs: "0" }} 
        >
          <Typography
            as='h2'
            fSize={{ md: 2, xxs: 1.5 }}
            lHeight={{ md: 2.375, xxs: 1.75 }}
            fWeight={700}
            mb={{ md: 0.938, xxs: 0.625 }}
          >
            {t("TELL_ABOUT_YOU_AND_YOUR_PROJECT")}
          </Typography>
          <Typography
            fSize={{ md: 1.063, xxs: 1 }}
            lHeight={1.813}
            fWeight={400}
            mb={{ md: 3.25, xxs: 1.5 }}
          >
            {
              !!contactInfo?.book_call ?
              <Trans
                i18nKey="TELL_ABOUT_YOU_AND_YOUR_PROJECT_DESCRIPTION"
                components={{
                  BookACall: (
                    <UnderLineText onClick={() => window.open(contactInfo?.book_call, '_blank')} />
                  ),
                  Icon: (
                    <IconWrapper
                      icon="outlined_arrowDiagonalRight"
                      size={1}
                      color='#5747B2'
                    />
                  ),
                }}
              />
              :
              t('TELL_ABOUT_YOU_AND_YOUR_PROJECT_DESCRIPTION_NO_LINK')
            }
          </Typography>
        </Block>
        <Box 
          w={{ md: "40%", xxs: "100%" }} 
          pl={{ md: 2, xxs: 0 }} 
          fJustify={{ md: "flex-end", xxs: "flex-start" }}
          fAlign='center'
          fDirection={{ xs: "row", xxs: "column" }}
          pt={{ md: 0, xxs: 2 }} 
        >
        {
          (
            contactInfo?.contact_email ||
            contactInfo?.contact_image ||
            contactInfo?.contact_job ||
            contactInfo?.contact_linkedin ||
            contactInfo?.contact_name ||
            contactInfo?.contact_phone
          ) &&
          <>
            {
              contactInfo?.contact_image?.url && 
              <Block position="relative">
                <Image
                  src={contactInfo?.contact_image?.url}
                  h={5}
                  w={5}
                  bRadius="50%"
                  alt='photo'
                />
                {
                  contactInfo?.contact_linkedin &&
                  <a target="_blank" href={contactInfo?.contact_linkedin} aria-label="LinkedIn Profile">
                    <LinkedInWrapper>
                      <Icon
                        icon="social_linkedin"
                        size={1}
                        color={colors.white}
                      />
                    </LinkedInWrapper>
                  </a>
                }
              </Block>
            }
            <Box 
              ml={{ xs: 1.688, xxs: 0 }} 
              mt={{ xs: 0, xxs: 1.688 }} 
              fDirection="column"
              fAlign={{ xs: 'flex-start', xxs: 'center' }}
            >
              {
                contactInfo?.contact_name &&
                <Typography
                  fSize={1.188}
                  lHeight={1.438}
                  fWeight={700}
                  mb={0.5}
                  tAlign='center'
                >
                  {contactInfo.contact_name}
                </Typography>
              }
              {
                contactInfo?.contact_job &&
                <Typography 
                  fSize={1.125} 
                  lHeight={1.375} 
                  fWeight={400}
                  mb={0.5}
                  tAlign='center'
                >
                  {contactInfo.contact_job}
                </Typography>
              }
              {
                contactInfo?.contact_email &&
                <Link href={`mailto:${contactInfo.contact_email}`} mb={0.125}>
                  <Typography 
                    fSize={1.063} 
                    lHeight={1.688} 
                    fWeight={400} 
                    mb={0.125}
                    hoverColor='#5747B2'
                    color={colors.black} 
                    style={{ textDecoration: 'none' }}
                    tAlign='center'
                  >
                    {contactInfo.contact_email}
                  </Typography>
                </Link>
              }
              {
                contactInfo?.contact_phone &&
                <>
                  <Link href={`tel:${contactInfo.contact_phone}`} >
                    <Typography
                      fSize={1.063} 
                      lHeight={1.688} 
                      fWeight={400}
                      hoverColor='#5747B2'
                      color={colors.black} 
                      style={{ textDecoration: 'none' }}
                      tAlign='center'
                    >
                      {contactInfo.contact_phone}
                    </Typography>
                  </Link>
                  <Typography 
                    fSize={0.75} 
                    lHeight={1} 
                    color={colors.black07}
                    tAlign='center'
                  >
                    {t('PHONE_LOCAL_COST')}
                  </Typography>
                </>
              }
            </Box>
          </>
        }
        </Box>
      </Box>
    </HeaderWrapper>
  );
};

export default ProjectForm;
